<template>
  <div class="dlnkdocs_component w-100">

    <div v-if="message" id="alert_message" class="alert alert-dismissible alert-modal" role="alert"
         :class="message_type">
      <button type="button" class="close" aria-label="Close" @click="close_message()">
        <span aria-hidden="true">&times;</span>
      </button>
      <span v-html="message"></span>
    </div>

    <div class="modal fade text-body" id="document_modal" tabindex="-1" role="dialog"
      aria-labelledby="new_document_modalLabel">
      <form id="document_form"
        enctype="multipart/form-data"
        method="post"
        @submit.prevent="post_document">
        <input type="hidden" name="method" :value="method">
        <input type="hidden" name="document_id" :value="document_id">
        <input type="hidden" name="group_id" :value="group_id">

        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title" id="new_document_modalLabel">Ajouter</h4>
              <button type="button" class="close" data-dismiss="modal" aria-label="Fermer"><span
                  aria-hidden="true">&times;</span></button>
            </div>
            <div class="modal-body">
              <div class="required form-group">
                <label for="title" class="required">
                  Titre
                </label>
                <input id="title" name="title" type="text"
                       class="is_required form-control"
                       :class="{'is-invalid': errors.title}"
                       @blur="validate_title"
                       v-model="title">
                <div class="invalid-feedback">
                  Le titre doit contenir entre 3 et 128 caractères.
                </div>
              </div>

              <div class="required form-group">
                <label for="description" class="">
                  Description
                </label>

                <textarea id="description"
                          name="description" rows="5"
                          class="form-control"
                          :class="{'is-invalid': errors.description}"
                          @blur="validate_description"
                          v-model="description"></textarea>

                <div class="invalid-feedback">
                  La description doit contenir au minimum 3 caractères.
                </div>
              </div>

              <div class="required form-group">
                <label for="section" class="required">
                  Section
                </label>
                <select id="section" name="section_id"
                        class="form-control"
                        :class="{'is-invalid': errors.section}"
                        @blur="validate_section"
                        v-model="section_id">
                  <option v-for="section in sections"
                          :key="section.id" 
                          :value="section.id">{{section.section}}
                  </option>
                </select>
                <div class="invalid-feedback">
                  Vous devez choisir une section
                </div>
              </div>

              <div v-if="typeof group_id == 'undefined' || group_id == 0">
                <div v-if="company.is_master_company">
                  <input id="is_community" v-model="is_community" type="checkbox" value="1" name="is_community" />
                  <label for="is_community">Accès pour toutes les communautés</label>
                </div>

                <div class="form-group" >
                  <input id="is_public" v-model="is_public" type="checkbox" value="1" name="is_public" />
                  <label for="is_public">Document public</label>
                </div>

                <div class="form-group">
                  <input id="visible_homepage" v-model="visible_homepage" type="checkbox" value="1" name="visible_homepage" />
                  <label for="visible_homepage">Visible sur la homepage</label>
                </div>
              </div>
              <div class="form-group">
                <label for="type">Type</label>
                <select id="type" name="type" class="form-control" v-model="type">
                  <option value=1>Document</option>
                  <option value=2>Vidéo</option>
                </select>
              </div>

              <div v-if="type == 1">
                <div class="form-group">
                  <input id="file" type="file" name="document_file"/>
                  <label for="file"> Taille maximum 30 Mo </label>

                  <div class="invalid-feedback">
                    Veuillez télécharger un document
                  </div>
                </div>
              </div>

              <div class="form-group" v-else-if="type == 2">
                <label for="video_url">URL (vidéo YouTube)</label>
                <input class="form-control" id="video_url" name="video_url" type="text" v-model="video_url">
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-primary" data-dismiss="modal">
                <i class="fa fa-times" aria-hidden="true"></i>&nbsp;Annuler
              </button>
              <button
                  :disabled="submit_disabled == true"
                  type="submit"
                  class="btn btn-primary"
                  name="new_document" >
                <i class="fa fa-save" aria-hidden="true"></i>&nbsp;Valider
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>

    <div class="clearfix"></div>

    <!-- Filter -->
    <div id="sortByTheme" class="mb-3">
      <span class="text">Catégories :</span>

      <a class="badge badge-soft-primary text-left mb-2 active"
         href="javascript:" id="section-0"
         @click="toggle_section(0)">
        Toutes
      </a>

      <a class="badge badge-soft-primary text-left mx-1 mb-2"
         :id="'section-' + section.id"
         href="javascript:"
         v-for="section in current_sections"
         :key="section.id"
         @click="toggle_section(section.id)">
        {{section.section}}
      </a>

    </div>

    <div class="row mb-3">
      <div class="col-4">
          <button @click="new_document()"
                  v-if="!!is_admin || member_status == 0"
                  type="button"
                  class="btn btn-primary float-right ml-1">
            <i class="fa fa-plus" aria-hidden="true"></i> &nbsp;Ajouter
          </button>
      </div>
      <div class="col-4">
        <div class="d-flex align-items-center justify-content-center justify-content-md-end text-center text-sm-left">
          <div class="dropdown dropleft">
            <button id='dropdown-sort' class="btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <i class="fa fa-filter mr-2"></i>Trier par
            </button>
            <div class="dropdown-menu dropdown-sort">
              <a class="dropdown-item" href="javascript:" v-on:click="sort('created_at', 'desc')">
                Date d'ajout (plus récents)
              </a>
              <a class="dropdown-item" href="javascript:" v-on:click="sort('created_at', 'asc')">
                Date d'ajout (plus anciens)
              </a>
              <a class="dropdown-item" href="javascript:" v-on:click="sort('updated_at', 'desc')">
                Date de modification (plus récents)
              </a>
              <a class="dropdown-item" href="javascript:" v-on:click="sort('updated_at', 'asc')">
                Date de modification (plus anciens)
              </a>
            </div>
          </div>
        </div>
      </div>

      <!-- SEARCH -->
      <div class="col-4">
        <input v-on:keyup="search_documents" type="text" placeholder="Rechercher ..." class="form-control-sm w-100 border" v-model="query">
      </div>
      <!-- END SEARCH -->

    </div>

    <div class="row">
      <dlnkdocs-document
          v-for="document in documents"
          :key="document.id"
          v-bind:document="document"
          v-bind:category="Number(category)"
          v-bind:is_admin="!!is_admin"
          @edit_document="edit_document($event)"
          @delete_document="delete_document($event)"
      ></dlnkdocs-document>
    </div>

  </div>
</template>

<script>

export default {
  props: ['group_id'],
  data: function () {
    return {
      sections: [],
      current_sections: [],
      documents: [],
      videos: [],
      query: '',
      order_by: 'updated_at',
      order_direction: 'desc',
      category: 0,
      company: Object,
      document_id: 0,
      title: '',
      description: '',
      is_public: false,
      visible_homepage: false,
      section_id: 0,
      type: 0,
      video_url: '',
      is_community: false,
      is_admin: false,
      member_status: 2,
      message: '',
      messsage_type: '',
      method: 'post',
      errors: {
        title: false,
        description: false,
        file: false,
        section: false,
      }
    }
  },
  mounted() {
    const _this = this;
    let group = "";
    _this.get_documents();

    if (typeof _this.group_id !== 'undefined') {
      group = '?group_id=' + _this.group_id;
    }

    axios.get('/modules/dlnkdocs/actions/sections.php' + group)
        .then(function (response) {
          _this.sections = response.data.sections
          _this.current_sections = response.data.current_sections
        })
        .catch(function (error) {
          console.log(error);
        })
        .then(function () {
              // always executed
            }
        );
  },

  computed: {
    submit_disabled: function () {
      return false;
    }
  },

  methods: {

    close_message: function () {
      this.message = null;
    },

    edit_document: function(document) {
      this.document_id = document.id;
      this.title = document.title;
      this.description = document.description;
      this.is_public = parseInt(document.is_public);
      this.visible_homepage = parseInt(document.visible_homepage);
      this.section_id = document.section_id;
      this.is_community = parseInt(document.is_community);
      this.type = document.type;
      this.video_url = document.video_url;
      this.method = 'patch'

      this.validate_fields()

      $('#document_modal').modal('show');
    },

    new_document: function(document) {
      this.document_id = 0;
      this.title = "";
      this.description = "";
      this.is_public = false;
      this.visible_homepage = false;
      this.section_id = 0;
      this.is_community = 0;
      this.type = 1;
      this.video_url = "";
      this.method = 'post'

      $('#document_modal').modal('show');
    },

    delete_document: function(document_id) {
      const _this = this;
      const url = '/modules/dlnkdocs/actions/documents.php';
      const form_data = new FormData();
      form_data.append('method', 'delete');
      form_data.append('document_id', document_id);

      axios({
        method: 'post',
        url: url,
        data: form_data,
        headers: {'Content-Type': 'multipart/form-data' }
      })
          .then(function (response) {
            //handle success
            const status = response.data.status;

            if(status) {
              _this.get_documents();
              _this.message = "Document supprimé.";
              _this.message_type = "alert-success"
            } else {
              _this.errors = response.data.errors;
            }
          })
          .catch(function (response) {
            //handle error
          });
    },

    get_documents: function () {
      const _this = this

      const url = '/modules/dlnkdocs/actions/documents.php'

      axios.get( url +
          '?group_id='        + _this.group_id +
          '&query='           + _this.query +
          '&order_by='        + _this.order_by +  
          '&order_direction=' + _this.order_direction)
          .then(function (response) {
            _this.documents = response.data.documents
            _this.company = response.data.company
            _this.is_admin = response.data.is_admin
            _this.member_status = response.data.member_status
          })
          .catch(function (error) {
            console.log(error);
          })
          .then(function () {
                // always executed
              }
          );
    },

    toggle_section: function (section_id) {
      this.category = section_id;

      $('#sortByTheme').children().removeClass('active');
      $('#sortByTheme').children( '#section-' + section_id ).addClass('active');
    },

    sort: function (order_by, order_direction) {
      this.get_documents();
      this.order_by = order_by;
      this.order_direction = order_direction;
      $('#dropdown-sort').dropdown('toggle');
    },

    validate_fields: function () {
      this.errors.description = false;
      this.errors.section = false;
      this.errors.title = false;

      this.validate_description();
      this.validate_section();
      this.validate_title();
    },

    validate_title: function () {
      this.errors.title = false;
      if(this.title.length < 3 || this.title.length > 128) {
        this.errors.title = true;
      }
    },

    validate_section: function () {
      this.errors.section = false;
      if(section < 0) {
        this.errors.title = true;
      }
    },

    validate_description: function () {
      this.errors.description = false;
      if(this.description.length < 3) {
        this.errors.description = true;
      }
    },

    post_document: function () {
      this.validate_fields();

      const _this = this;
      const url = '/modules/dlnkdocs/actions/documents.php';

      const form_element = document.getElementById("document_form");
      const form_data = new FormData(form_element);

      axios({
        method: 'post',
        url: url,
        data: form_data,
        headers: {'Content-Type': 'multipart/form-data' }
      })
      .then(function (response) {
        //handle success
        const status = response.data.status;

        if(status) {
          $('#document_modal').modal('hide');
          _this.get_documents();
          if (_this.method === 'post') {
            _this.message = "Document ajouté.";
            _this.message_type = "alert-success"
          } else if (_this.method === 'patch') {
            _this.message = "Document modifié.";
            _this.message_type = "alert-success"
          }
        } else {
          _this.errors = response.data.errors;
        }
      })
      .catch(function (response) {
        //handle error
      });
    },

    search_documents() {
      this.get_documents();
    }
  },
}
</script>
